import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const PHASES = [
  { label: "Inhale", duration: 4 },
  { label: "Hold", duration: 7 },
  { label: "Exhale", duration: 8 },
];

export const BreathingVisualizer = () => {
  const [phaseIndex, setPhaseIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPhaseIndex((p) => (p + 1) % PHASES.length);
    }, PHASES[phaseIndex].duration * 1000);
    return () => clearTimeout(timer);
  }, [phaseIndex]);

  const phase = PHASES[phaseIndex];
  const scale = phase.label === "Inhale" ? 1.4 : phase.label === "Exhale" ? 0.85 : 1.4;

  return (
    <div className="flex flex-col items-center gap-6" data-testid="breathing-visualizer">
      <motion.div
        animate={{ scale }}
        transition={{ duration: phase.duration, ease: "easeInOut" }}
        className="w-40 h-40 rounded-full flex items-center justify-center"
        style={{ background: "radial-gradient(circle, rgba(74,107,86,0.35) 0%, rgba(196,123,94,0.2) 70%, transparent 100%)" }}
      >
        <span className="text-[#232B25] font-serif text-lg" data-testid="breathing-phase-label">
          {phase.label}
        </span>
      </motion.div>
      <p className="text-sm text-[#5F6A62] uppercase tracking-[0.2em]">4 - 7 - 8 Grounding Breath</p>
    </div>
  );
};
